import { Cbo } from 'graphql/types.generated'

import {
  EquipeLotacaoResponsavel,
  LotacaoResponsavelFormModel,
  ProfissionalLotacaoResponsavel,
  UnidadeSaudeLotacaoResponsavel,
} from '../model-lotacaoResponsavel'

export const getLotacaoResponsavel = (
  profissional: ProfissionalLotacaoResponsavel,
  cbo: Cbo,
  equipe: EquipeLotacaoResponsavel,
  unidadeSaude: UnidadeSaudeLotacaoResponsavel,
  lotacaoId?: ID,
  __typename?: string
): LotacaoResponsavelFormModel => ({
  lotacao: {
    __typename: __typename,
    id: lotacaoId,
    profissional: profissional,
    cbo: cbo,
    equipe: equipe,
    unidadeSaude: unidadeSaude,
  },
})

type EquipeLabel = { nome?: string | null; ine?: string | null }

type UnidadeSaudeLabel = { nome?: string | null; cnes?: string | null }

export const formatEquipeLotacaoResponsavel = (equipe: EquipeLabel | null | undefined, fallback: string): string => {
  if (!equipe?.nome) return fallback

  return equipe.ine ? `${equipe.nome} - ${equipe.ine}` : equipe.nome
}

export const formatUnidadeSaudeLotacaoResponsavel = (unidadeSaude: UnidadeSaudeLabel | null | undefined): string => {
  if (!unidadeSaude?.nome) return 'Sem unidade de saúde'

  return unidadeSaude.cnes ? `${unidadeSaude.nome} - ${unidadeSaude.cnes}` : unidadeSaude.nome
}
